var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [_c("span", { staticClass: "header-item" }, [_vm._v("Bitrate Data")])]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "card-content",
      },
      [
        _vm.dataLoaded
          ? _c(
              "div",
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  _vm._l(_vm.images, function (value, key) {
                    return _c(
                      "el-col",
                      { key: key, attrs: { span: _vm.spanPerImage } },
                      [
                        _c("img", {
                          staticStyle: { width: "100%" },
                          attrs: { src: "data:image/svg+xml;base64," + value },
                        }),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _c("div", [
              _c(
                "div",
                { staticStyle: { "text-align": "center", margin: "40px" } },
                [
                  _c(
                    "a",
                    {
                      staticClass: "el-button el-button--primary",
                      on: {
                        click: function ($event) {
                          return _vm.loadImages()
                        },
                      },
                    },
                    [
                      _vm._v("\n          Load Bitrate data "),
                      _c("i", { staticClass: "el-icon-download" }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "center" } }, [
                    _c("small", [_vm._v("This request may take a while")]),
                  ]),
                ]
              ),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }